import React, { useEffect, useState } from 'react';
import { Header, Segment, Pagination } from 'semantic-ui-react';
import { connect } from 'react-redux'
import moment from 'moment'
import TitleBar from '../titleBar/titleBar';
import AgGridTable from '../agGridComponent/agGridTable';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder'

import PurchaseOrderActionButton from './purchaseOrderActionButton';
import PdfActionButton from './pdfActionButton';

import { deletePurchaseOrder, getPurchaseOrder, getPurchaseOrderPagination, getGeneratedPdf } from '../../redux/actions/purchaseOrderActions';
import { DATE_FORMATS } from '../../config/const';


function ProductTable(props) {
    const [purchaseOrderCurrentPageData, setPurchaseOrderCurrentPageData] = useState(1)
    const [isFilter, setIsFilter] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [filteredData, setFilteredData] = useState({})

    const { purchaseOrderData, purchaseOrderPagination, purchaseOrderLoading, getPurchaseOrder, getPurchaseOrderPagination, deletePurchaseOrder, deletePurchaseOrderIsLoading, getGeneratedPdf } = props;
    
    useEffect(() => {
        if(props.searchValue){
            setIsSearch(true)
        }
        setPurchaseOrderCurrentPageData(1)
        const filteredData = {
            api_token: localStorage.getItem('apiToken'),
            customerNo: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            searchString: props.searchValue ? props.searchValue : ''
          }
          setFilteredData(filteredData)

        getPurchaseOrderPagination(1,filteredData)

    },[props.searchValue])

    const handlePaginationChange = (e, { activePage }) => {

        if (isFilter) {
            getPurchaseOrderPagination(activePage, filteredData)
            setPurchaseOrderCurrentPageData(activePage)
        } else if(isSearch){
            getPurchaseOrderPagination(activePage,filteredData)
            setPurchaseOrderCurrentPageData(activePage)
        }else {
            getPurchaseOrderPagination(activePage)
            setPurchaseOrderCurrentPageData(activePage)
        }

    }

    const getFilterDates = (searchValue,startDate, endDate, billStatus,vendorCode, vehicleNo, vehicleId,branch,lrNo) => {
        setIsFilter(true)
        setPurchaseOrderCurrentPageData(1)
        const filteredData = {
          api_token: localStorage.getItem('apiToken'),
          customerNo: localStorage.getItem('customerNo'),
          userId: localStorage.getItem('userId'),
          fromDate: moment(startDate).format(DATE_FORMATS.DD_MM_YYYY),
          toDate: moment(endDate).format(DATE_FORMATS.DD_MM_YYYY),
          billStatus:billStatus ? [billStatus] : [],
          vendorCode:vendorCode ? vendorCode : '',
          vehicleId:vehicleId ? vehicleId : '',
          branch:branch ? branch :'',
          searchString: props.searchValue ? props.searchValue : '',
          lrNumbers:lrNo ? lrNo :''
        }
        setFilteredData(filteredData)   
        getPurchaseOrderPagination(1,filteredData)
      }

        let columnDefs = [
            { headerName: 'PO No.', field: 'poNumber', tooltipField: 'poNumber', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Order No.', field: 'orderNo', tooltipField: 'orderNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'LR No', field: 'lrNo', tooltipField: 'lrNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vendor LR No', field: 'vendorLrNo', tooltipField: 'vendorLrNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'PO Date', field: 'poDate', tooltipField: 'poDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Reference No.', field: 'refNo', tooltipField: 'refNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Partner Name', field: 'vendorName', tooltipField: 'vendorName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Amount (Rs)', field: 'amount', tooltipField: 'amount', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Branch', field: 'branch', tooltipField: 'branch', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Remarks', field: 'remarks', tooltipField: 'remarks', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle', field: 'vehicle', tooltipField: 'vehicle', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created On', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created By', field: 'createdBy', tooltipField: 'createdBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Modified On', field: 'modifiedOn', tooltipField: 'modifiedOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Modified By', field: 'modifiedBy', tooltipField: 'modifiedBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'PDF', field: 'pdf', cellRenderer: 'pdfRenderer', width: 100, suppressToolPanel: true },
            { headerName: 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', width: 280, suppressToolPanel: true, pinned: "right" }
        ]

        let columnKeys = ['poNumber', 'poDate', 'refNo', 'vendorName', 'amount', 'branch', 'vehicle', 'createdOn', 'createdBy', 'modifiedOn', 'modifiedBy']

        let frameworkComponents = {
            actionRenderer: PurchaseOrderActionButton,
            pdfRenderer: PdfActionButton
        }

        let rowData = []
        purchaseOrderData && purchaseOrderData.forEach((object, index) => {
            let temp = {}
            temp.poNumber = object.poNumber
            temp.poDate = moment(object.poDate).format('DD-MM-YYYY') === "Invalid date" ? "" : moment(object.poDate).format('DD-MM-YYYY')
            temp.refNo = object.poReferenceNo
            temp.orderNo = object.orderNo
            temp.vendorName = object.vendorName
            temp.vendorId = object.vendorId
            temp.vendorGroup = object.purchasePrice
            temp.amount = object.totalOrderAmt
            temp.branch = object.branchName
            temp.vehicle = object.vehicleNo
            temp.remarks = object.remarks
            temp.createdOn = object.createdOn
            temp.createdBy = object.createdByName
            temp.modifiedOn = object.updatedOn
            temp.modifiedBy = object.updatedByName
            temp.deletePurchaseOrder = deletePurchaseOrder
            temp.isLoading = deletePurchaseOrderIsLoading
            temp.getGeneratedPdf = getGeneratedPdf
            //Extra Data for Edit
            temp.psLineItem = object.po_details
            temp.poId = object.poId
            temp.isUsed = object.isUsed
            temp.lrNo = object.lrNumbers
            temp.vendorLrNo = object.vendorLrNumbers
            rowData[index] = temp
        })


        return (
            <React.Fragment>
                <AgGridTable
                    columnDefs={columnDefs}
                    columnKeys={columnKeys}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    link="/add-purchaseorder"
                    baseURL={props}
                    pagination={false}
                    hiddenNewPopupBtn={true}
                    hiddenImportPopupBtn={true}
                    extraComponents={frameworkComponents}
                    titleBarTitle="Purchase Order"
                    handleSearch={props.handleSearch}
                    getFilterDates={getFilterDates}
                    PO={true}
                    dataLoading={purchaseOrderLoading}
                    purchaseOrderData={purchaseOrderData}
                />
                <Pagination
                    key={purchaseOrderPagination?.currentPage}
                    defaultActivePage={
                        purchaseOrderPagination?.currentPage
                    }
                    firstItem={null}
                    lastItem={null}
                    onPageChange={handlePaginationChange}
                    pointing
                    secondary
                    totalPages={
                        purchaseOrderPagination?.totalPages
                            ? purchaseOrderPagination?.totalPages
                            : 0
                    }
                />
            </React.Fragment>
        )
    }


const mapStatetoProps = (state) => ({
    purchaseOrderData: state.getPurchaseOrderData.purchaseOrder.data,
    purchaseOrderLoading: state.getPurchaseOrderData.isLoading,
    deletePurchaseOrderIsLoading: state.deletePurchaseOrderData.isLoading,
    purchaseOrderPagination: state.getPurchaseOrderData.purchaseOrderPagination
})

export default connect(mapStatetoProps, { getPurchaseOrder, deletePurchaseOrder, getGeneratedPdf, getPurchaseOrderPagination })(ProductTable)